import { render, staticRenderFns } from "./NumeratoriViewPage.vue?vue&type=template&id=2497d91e"
import script from "./NumeratoriViewPage.vue?vue&type=script&lang=js"
export * from "./NumeratoriViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports